if (!customElements.get('dawn-footer-navigation')) {
  customElements.define(
    'dawn-footer-navigation',
    class extends HTMLElement {
      connectedCallback() {
        this.details = this.querySelector('details');
        this.summary = this.details?.querySelector('summary');
        this.desktop = window.matchMedia('(min-width: 750px)');

        if (!this.details || !this.summary) return;

        this.updateLayout = () => {
          this.details.open = this.desktop.matches;
          this.summary.tabIndex = this.desktop.matches ? -1 : 0;
        };
        this.preventDesktopCollapse = (event) => {
          if (this.desktop.matches) event.preventDefault();
        };

        this.desktop.addEventListener('change', this.updateLayout);
        this.summary.addEventListener('click', this.preventDesktopCollapse);
        this.updateLayout();
      }

      disconnectedCallback() {
        this.desktop?.removeEventListener('change', this.updateLayout);
        this.summary?.removeEventListener('click', this.preventDesktopCollapse);
      }
    }
  );
}
